import {ReactNode, useContext, useEffect, useState} from "react";
import QRCodeStyleDialogContext from "./QRCodeStyleDialogContext";
import SimpleQRCode from "../../../../api/qr-code/SimpleQRCode";
import QRCodeContext from "../../../../contexts/qr-code/QRCodeContext";

type Props = {
    /**
     * Children to be wrapped
     * @since 0.1.9
     * @author Kacper Faber
     */
    children: ReactNode | ReactNode[];
};

function WrapQRCodeStyleDialogContext(props: Props) {
    /**
     * QRCode to edit design in.
     * Should be set for dialog 'appear' and deleted when dialog is disappeared
     * @author Kacper Faber
     * @since 0.1.9
    */
    const [qrCode, setQrCode] = useState<SimpleQRCode>();

    /**
     * QRCodeContext
     * @author Kacper Faber
     * @since 0.1.9
     */
    const qrContext = useContext(QRCodeContext);

    /**
     * Is dialog opened
     * @since 0.1.9
     * @author Kacper Faber
     */
    const [isOpened, setOpened] = useState(false);

    /**
     * Close the dialog
     * @since 0.1.9
     * @author Kacper Faber
     */
    const close = () => {
        setOpened(false);
        qrContext.reload();
    }

    /**
     * Open the dialog
     * @since 0.1.9
     * @author Kacper Faber
     */
    const open = (qrCode: SimpleQRCode) => {
        setQrCode(qrCode);
        setOpened(true);
    }

    /**
     * To be called when isOpened state is changed.
     * Should delete QRCode state and generally, prepare dialog for dispose
     * @author Kacper Faber
     * @since 0.1.9
    */
    const onVisibilityChanged = () => {
        if (!isOpened) {
            setQrCode(undefined);
        }
    };

    useEffect(onVisibilityChanged, [isOpened]);

    return (
        <QRCodeStyleDialogContext.Provider
            children={props.children}
            value={{ open, close, isOpened, qrCode }}
        />
    );
}

export default WrapQRCodeStyleDialogContext;